export enum EnumCampoDinamicoValidationType {
  Pattern = 0,
  Required = 1,
  Min = 2,
  MinLength = 3,
  Max = 4,
  MaxLength = 5,
  Email = 6
}
